import getConfigService from './getConfigService';

const getConfig = async (data) => {
  try {
    const configData = await getConfigService(data);
    return configData || null;
  } catch (e) {
    return null;
  }
};

export default getConfig;
